import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from '@redux';
import crudActions from '@redux/crudActions';
import { useGetFilter } from 'hooks/useSearchParamsObj';
import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { DynamicObjectType } from 'types/commons';
import { formatDateTime } from 'utils/formattedString';
import { getIdByUrl } from 'utils/tools';

const BatchBreadCrumb = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const { searchParams } = useGetFilter();

  const currentData = useSelector<DynamicObjectType>(
    (state) => state.orderBatches.currentData,
  );

  const _id = useMemo(
    () => getIdByUrl({ model: 'order-management' }, location) || params.id,
    [params.id],
  );

  useEffect(() => {
    dispatch(
      crudActions.orderBatches.getDataById({
        data: { id: _id },
        options: {
          isRequestApi: true,
        },
      }),
    );
  }, [_id]);
  return (
    <div>
      <FontAwesomeIcon
        icon={faChevronLeft}
        className="cursor-pointer"
        onClick={() => {
          searchParams.get('tab') !== 'picking' &&
            dispatch(crudActions['orderBatches'].clearCurrent());
          window.history.back();
        }}
      />
      <span className="font-bold text-sm ml-2.5">{`Batch ID ${formatDateTime(currentData?.createdAt, 'DDMMYYYY')}_${currentData?.id}`}</span>
    </div>
  );
};

export default BatchBreadCrumb;
